import {
	StatusLabel,
} from "~/components";
import {Pagination, Table} from "antd";
import {useContext} from "react";
import {AppContext} from "~/context/AppProvider";
import {renderAddress} from "~/utils";
import CustomerAction from "./CustomerAction";
import {SelectField} from "~/components/Forms";
import {
	DATA_LIMIT,
	DATA_LIMIT_KEY
} from "~/app/constants";

function CustomerTable({items = [], pagination, setItemEdit, openModal, onPaginationChange, onLimitChange, can, country}) {

	const {tableHeight} = useContext(AppContext);

	let columns = [
		{ title: 'ID', dataIndex: 'id', key: "id", width: '100px', render: (_, item) => (
			<b>#{item.id}</b>
		)},
		{ title: 'Tên', dataIndex: 'name', key: "name", width: '180px', render: (_, item) => (
			<p>{item?.name}</p>
		)},
		{ title: 'Liên hệ', dataIndex: 'contact', key: "contact", width: '150px', render: (_, item) => (
			<>
				<p>{item?.phone}</p>
				<p>{item?.email}</p>
			</>
		)},
		{ title: 'Địa chỉ', dataIndex: 'address', key: "address", width: '600px', render: (_, item) => (
			<>
			<p>{item.address}</p>
			<p className="italic color-red">{renderAddress(
				item?.city,
				item?.district,
				item?.ward,
				country)}</p>
			</>
		)},
		{ title: 'Trạng thái', dataIndex: 'status', key: "status", width: '100px', render: (_, item) => (
			<div>
				<>
					{item?.percent <= 3 && <StatusLabel small background type="green">An toàn</StatusLabel>}
					{item?.percent > 3 && item?.percent <= 10 && <StatusLabel small background type="yellow">Cẩn thận</StatusLabel>}
					{item?.percent > 10 && <StatusLabel small background type="red">Nguy hiểm</StatusLabel>}
				</>
			</div>
		)},
		{ title: '#', dataIndex: 'action', key: "action", width: '100px', render: (_, item) => (
			<CustomerAction item={item} setItemEdit={setItemEdit} openModal={openModal} can={can}/>
		)},
	];

	const dataSource= items.map(row => ({
		key: row.id, // I added this line
		...row
	}));

	return (
		<div className="table-wrapper">
			<div className="table-box">
				<Table
					columns={columns} dataSource={dataSource} scroll={{ y:tableHeight, x: 'max-content' }} pagination={false}
				/>
			</div>
			<div className="d-flex justify-content-end">
				<Pagination current={pagination.page} defaultCurrent={1} defaultPageSize={20} pageSize={pagination.limit} total={pagination.totalRows} onChange={onPaginationChange}  showSizeChanger={false} />
				<SelectField defaultValue={(localStorage.getItem(DATA_LIMIT_KEY) != undefined) ? parseInt(localStorage.getItem(DATA_LIMIT_KEY)) : DATA_LIMIT} options={[
					{value: 50, label: '50 / Trang'},
					{value: 100, label: '100 / Trang'},
					{value: 200, label: '200 / Trang'},
					{value: 500, label: '500 / Trang'},
				]} onChange={onLimitChange} />
			</div>

		</div>
	)
}

export default CustomerTable;